<template>
  <el-checkbox
    :value="tjbForm[key]"
    true-label="1"
    false-label="0"
    @change="onChange"
  >{{label}}</el-checkbox>
</template>

<script>
import storeMixins from '../store-mixins'
export default {
  mixins: [storeMixins],
  props: ['props'],
  data() {
    return {
      isHasOptionsComp: true,
    }
  },
  computed: {
    key() {
      return this.props.name
    },
    label() {
      return this.props.extraLabel || this.props.dataSource.label || '未知'
    }
  },
  methods: {
    onChange(v) {
      const newFormFields = {}
      newFormFields[this.key] = v
      this.updateTjbForm(newFormFields)
    },
  },
};
</script>
